<!-- Container -->
<div class="sel" [class.with-title]="!!cardTitle">

    <!-- Optional card header: makes the selector its own V2 card (no card-in-card nesting).
         Mirrors a primaryCardHeader mat-card-title + subtitle. -->
    <div class="sel-card-head" *ngIf="cardTitle">
        <div class="sel-card-title">{{ cardTitle }}</div>
        <div class="sel-card-subtitle" *ngIf="cardSubtitle">{{ cardSubtitle }}</div>
    </div>

    <!-- Toolbar -->
    <div class="toolbar">
        <div class="search">
            <span class="search-icon">
                <i class="ph-bold ph-magnifying-glass icon-muted icon-16" aria-hidden="true"></i>
            </span>
            <input type="text"
                   placeholder="Search units, owners, addresses..."
                   [ngModel]="searchString"
                   (ngModelChange)="onSearchInput($event)">
            <button type="button"
                    class="search-x"
                    *ngIf="searchString"
                    (click)="clearSearch()">
                &times;
            </button>
        </div>

        <button type="button"
                class="tb-btn"
                [class.active]="filterPanelOpen"
                [class.has-badge]="activeFilterCount > 0"
                (click)="toggleFilterPanel()">
            <i class="ph-bold ph-funnel icon-muted icon-16" aria-hidden="true"></i>
            Filters
            <span class="badge">{{ activeFilterCount }}</span>
        </button>

        <span class="sel-count">
            <b>{{ selection?.selected.length || 0 }}</b> of {{ totalRecords }} selected
        </span>
    </div>

    <!-- Filter panel -->
    <div class="filters" [class.open]="filterPanelOpen">
        <!-- Balance (multi-select dropdown, same pattern as tags) -->
        <div class="fg fg-narrow">
            <span class="fg-label">Balance</span>
            <div class="tag-wrap">
                <button type="button"
                        class="tag-trigger"
                        [class.has-sel]="balanceFilters.size > 0"
                        (click)="toggleBalanceDropdown(); $event.stopPropagation()">
                    {{ balanceFilters.size > 0 ? balanceFilters.size + ' active' : 'Any' }}
                </button>
                <div class="tag-dd" [class.open]="balanceDropdownOpen">
                    <div *ngFor="let opt of balanceOptions; trackBy: trackByBalanceOption"
                         class="tag-dd-item"
                         [class.state-has]="isBalanceFilterActive(opt.value)"
                         (click)="toggleBalanceFilter(opt.value); $event.stopPropagation()">
                        <div class="t-indicator"></div>
                        <span class="t-label">{{ opt.label }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Unit tags -->
        <div class="fg">
            <span class="fg-label">Unit tags</span>
            <div class="tag-wrap">
                <button type="button"
                        class="tag-trigger"
                        [class.has-sel]="selectedUnitTags.selected.length > 0"
                        (click)="toggleUnitTagDropdown(); $event.stopPropagation()">
                    {{ unitTagInputText || 'Select tags...' }}
                </button>
                <div class="tag-dd" [class.open]="unitTagDropdownOpen">
                    <div class="tag-dd-hint">Click to include · click again to exclude · third click removes</div>
                    <div *ngFor="let tag of availableUnitTags; trackBy: trackByTagId"
                         class="tag-dd-item"
                         [class.state-has]="getUnitTagState(tag.tag) === 'has'"
                         [class.state-not]="getUnitTagState(tag.tag) === 'not'"
                         (click)="toggleUnitTag(tag); $event.stopPropagation()">
                        <div class="t-indicator"></div>
                        <span class="t-label">{{ tag.tag }}</span>
                        <span class="t-state-label">
                            {{ getUnitTagState(tag.tag) === 'has' ? 'include' : getUnitTagState(tag.tag) === 'not' ? 'exclude' : '' }}
                        </span>
                    </div>
                    <div *ngIf="availableUnitTags.length === 0" class="tag-dd-empty">
                        No tags available
                    </div>
                </div>
            </div>
        </div>

        <!-- Owner tags -->
        <div class="fg">
            <span class="fg-label">Owner tags</span>
            <div class="tag-wrap">
                <button type="button"
                        class="tag-trigger"
                        [class.has-sel]="selectedOwnerTags.selected.length > 0"
                        (click)="toggleOwnerTagDropdown(); $event.stopPropagation()">
                    {{ ownerTagInputText || 'Select tags...' }}
                </button>
                <div class="tag-dd" [class.open]="ownerTagDropdownOpen">
                    <div class="tag-dd-hint">Click to include · click again to exclude · third click removes</div>
                    <div *ngFor="let tag of availableOwnerTags; trackBy: trackByTagId"
                         class="tag-dd-item"
                         [class.state-has]="getOwnerTagState(tag.tag) === 'has'"
                         [class.state-not]="getOwnerTagState(tag.tag) === 'not'"
                         (click)="toggleOwnerTag(tag); $event.stopPropagation()">
                        <div class="t-indicator"></div>
                        <span class="t-label">{{ tag.tag }}</span>
                        <span class="t-state-label">
                            {{ getOwnerTagState(tag.tag) === 'has' ? 'include' : getOwnerTagState(tag.tag) === 'not' ? 'exclude' : '' }}
                        </span>
                    </div>
                    <div *ngIf="availableOwnerTags.length === 0" class="tag-dd-empty">
                        No tags available
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Backdrop to close dropdowns -->
    <div class="backdrop" *ngIf="unitTagDropdownOpen || ownerTagDropdownOpen || balanceDropdownOpen" (click)="closeAllDropdowns()"></div>

    <!-- Active filter chips -->
    <div class="chips-bar" *ngIf="activeFilterCount > 0">
        <span class="chips-label">Filtered:</span>

        <ng-container *ngFor="let bf of balanceFilters; trackBy: trackByBalanceFilter">
            <span class="chip">
                {{ getBalanceFilterLabel(bf) }}
                <button type="button" class="chip-x" (click)="removeBalanceFilterChip(bf)">&times;</button>
            </span>
        </ng-container>

        <ng-container *ngFor="let tag of selectedUnitTags.selected; trackBy: trackByTagId">
            <span class="chip" [class.neg]="tag.filter === 'not_equals'">
                <button type="button" class="chip-body" (click)="toggleChipMode(tag, 'unit')">
                    <span *ngIf="tag.filter === 'not_equals'" class="chip-mode">NOT</span>
                    {{ tag.tag }}
                </button>
                <button type="button" class="chip-x" (click)="removeUnitTag(tag)">&times;</button>
            </span>
        </ng-container>

        <ng-container *ngFor="let tag of selectedOwnerTags.selected; trackBy: trackByTagId">
            <span class="chip" [class.neg]="tag.filter === 'not_equals'">
                <button type="button" class="chip-body" (click)="toggleChipMode(tag, 'owner')">
                    <span *ngIf="tag.filter === 'not_equals'" class="chip-mode">NOT</span>
                    {{ tag.tag }}
                </button>
                <button type="button" class="chip-x" (click)="removeOwnerTag(tag)">&times;</button>
            </span>
        </ng-container>

        <button type="button" class="chips-clear" (click)="clearAllFilters()">Clear all</button>
    </div>

    <!-- Selection bar -->
    <div class="sel-bar" *ngIf="selection?.selected.length > 0">
        <span class="sel-bar-txt">{{ selection.selected.length }} unit{{ selection.selected.length !== 1 ? 's' : '' }} selected</span>
        <div class="sel-bar-actions">
            <button type="button" class="sel-bar-btn" (click)="selectAllWithBalance()">Select all with balance</button>
            <button type="button" class="sel-bar-btn" (click)="selectAllVisible()">Select all ({{ filteredUnits.length }})</button>
            <button type="button" class="sel-bar-btn muted" (click)="deselectAll()">Deselect all</button>
        </div>
    </div>

    <!-- Loading indicator (background page loading) -->
    <div class="loading-bar-info" *ngIf="isLoadingUnits && units.length > 0">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <span class="loading-bar-text">Loading units... {{ units.length }} of {{ totalRecords }}</span>
    </div>

    <!-- Table (rows are the ONLY scrollable region — toolbar/title/footer stay pinned
         when a host constrains the component's height) -->
    <div class="tbl-scroll" *ngIf="filteredUnits.length > 0">
    <table>
        <thead>
            <tr>
                <th class="cbox">
                    <div class="ck"
                         [class.on]="isAllSelected()"
                         [class.mid]="isSomeSelected()"
                         (click)="toggleAll()">
                    </div>
                </th>
                <th class="sortable" [class.active]="sortColumn === 'name'" (click)="toggleSort('name')">
                    Unit <span class="sort-arrow" *ngIf="sortColumn === 'name'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
                </th>
                <th>Address</th>
                <th>Tags</th>
                <th class="r sortable" [class.active]="sortColumn === 'balance'" (click)="toggleSort('balance')">
                    Balance <span class="sort-arrow" *ngIf="sortColumn === 'balance'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
                </th>
                <th class="r sortable" [class.active]="sortColumn === 'pastDueBalance'" (click)="toggleSort('pastDueBalance')">
                    Past Due <span class="sort-arrow" *ngIf="sortColumn === 'pastDueBalance'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
                </th>
                <th>Owners</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let unit of pagedUnits; trackBy: trackByUnitId"
                [class.on]="isSelected(unit)"
                (click)="toggleRow(unit)">
                <td class="cbox" (click)="$event.stopPropagation(); toggleRow(unit)">
                    <div class="ck" [class.on]="isSelected(unit)"></div>
                </td>
                <td>
                    <div class="u-title" [innerHTML]="highlight(unit.name)"></div>
                    <div class="u-match" *ngIf="getMatchSource(unit) as matchSrc">
                        <span [innerHTML]="highlight(matchSrc)"></span>
                    </div>
                </td>
                <td>
                    <div class="u-addr-line" [innerHTML]="highlight(unit.address?.line1 || '')"></div>
                    <div class="u-addr-city">
                        <span [innerHTML]="highlight(unit.address?.city || '')"></span><ng-container *ngIf="unit.address?.region">, <span [innerHTML]="highlight(unit.address.region)"></span></ng-container><ng-container *ngIf="unit.address?.postalCode">&nbsp;<span [innerHTML]="highlight(unit.address.postalCode)"></span></ng-container>
                    </div>
                </td>
                <td>
                    <div class="u-tags" *ngIf="unit.tags?.length > 0">
                        <span *ngFor="let tag of unit.tags; trackBy: trackByTagId"
                              class="u-tag"
                              [ngClass]="tagColorClass(tag)">
                            {{ tag.tag }}
                        </span>
                    </div>
                    <span *ngIf="!unit.tags?.length" class="no-tags">&mdash;</span>
                </td>
                <td class="r">
                    <span class="u-bal" [class.zero]="unit.balance === 0">
                        {{ unit.balance | legfiCurrency:'USD':'symbol':'.2' }}
                    </span>
                </td>
                <td class="r">
                    <span class="u-bal" [class.zero]="unit.pastDueBalance === 0">
                        {{ unit.pastDueBalance | legfiCurrency:'USD':'symbol':'.2' }}
                    </span>
                </td>
                <td>
                    <div class="u-owners">
                        <span *ngFor="let owner of unit.owners; trackBy: trackByOwnerId"
                              class="u-owner"
                              [innerHTML]="highlight(owner.name)">
                        </span>
                    </div>
                    <span *ngIf="!unit.owners?.length" class="no-tags">No owners</span>
                </td>
            </tr>
        </tbody>
    </table>
    </div>

    <!-- Empty state -->
    <div class="empty" *ngIf="!isLoadingUnits && filteredUnits.length === 0">
        <div class="empty-t">No units match</div>
        <div class="empty-s">Try adjusting your search or filters</div>
    </div>

    <!-- Loading state (initial) -->
    <div class="empty" *ngIf="isLoadingUnits && units.length === 0">
        <div class="empty-t">Loading units...</div>
    </div>

    <!-- Footer with pagination -->
    <div class="foot" *ngIf="filteredUnits.length > 0">
        <span class="foot-info">
            Showing <b>{{ currentPage * pageSize + 1 }}&ndash;{{ (currentPage + 1) * pageSize > filteredUnits.length ? filteredUnits.length : (currentPage + 1) * pageSize }}</b> of <b>{{ filteredUnits.length }}</b>
            <ng-container *ngIf="filteredUnits.length !== totalRecords"> ({{ totalRecords }} total)</ng-container>
        </span>
        <div class="foot-pagination" *ngIf="showPagination">
            <button type="button" class="foot-page-btn" [disabled]="currentPage === 0" (click)="goToPage(currentPage - 1)">&lsaquo; Prev</button>
            <span class="foot-page-info">Page {{ currentPage + 1 }} of {{ totalPages }}</span>
            <button type="button" class="foot-page-btn" [disabled]="currentPage >= totalPages - 1" (click)="goToPage(currentPage + 1)">Next &rsaquo;</button>
        </div>
    </div>
</div>
